module.exports = __webpack_public_path__ + "static/media/DG_x_MU_Banner_visual_new_02.efbfbfa2.png";